import { REDUX_ACTIONS, GAME_ID } from '../../data/wordCityConstants';

const initialState = {
  isRewardMode: false,
  isJiggleWreckingBallMode: false,
  isOnboardingMode: false,
  isStandardMode: false,
};

const wordCityGameModeReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.TURN_REWARD_MODE_ON: {
      return {
        ...state,
        isRewardMode: true,
      };
    }
    case REDUX_ACTIONS.TURN_REWARD_MODE_OFF: {
      return {
        ...state,
        isRewardMode: false,
      };
    }
    // isRewardMode's only other reset is a timeout in WordCityRewardOnTopScreen, which dies with the
    // screen if the child leaves mid-reward, leaving the next topper item to unlock itself on sight
    case REDUX_ACTIONS.INIT_STANDARD_ROUND:
    case REDUX_ACTIONS.INIT_ONBOARDING_ROUND: {
      return {
        ...state,
        isRewardMode: false,
      };
    }
    case REDUX_ACTIONS.SWITCH_JIGGLE_WRECKING_BALL_MODE: {
      return {
        ...state,
        isJiggleWreckingBallMode: !state.isJiggleWreckingBallMode,
      };
    }
    case REDUX_ACTIONS.TURN_ONBOARDING_MODE_ON: {
      return {
        ...state,
        isOnboardingMode: true,
        isStandardMode: false,
      };
    }
    case REDUX_ACTIONS.TURN_STANDARD_MODE_ON: {
      return {
        ...state,
        isOnboardingMode: false,
        isStandardMode: true,
      };
    }
    default:
      return state;
  }
};

export default wordCityGameModeReducer;
